/* eslint-disable import/prefer-default-export */
import { EMAIL_REGEX } from '../constants';

const EMAIL_MINIMAL_LENGTH = 6;

const validations = [

  (email) => {
    const validate = email && typeof email === 'string' && email.length > EMAIL_MINIMAL_LENGTH;

    return validate === true ? null : `Email should have at least ${EMAIL_MINIMAL_LENGTH} characters`;
  },

  // validate Email Using a regex
  (email) => {
    const validate = email && typeof email === 'string' && EMAIL_REGEX.test(email);

    return validate === true ? null : 'Invalid email format';
  },
];

/**
  * Runs your provided email against a series of validations defined by the developers
  * @param {string} email
  */
export const validateEmail = (email) => validations.map(validation => validation(email)).filter(validationError => (typeof validationError === 'string'));
